import styled from 'styled-components'

export const Logo = styled.img `
  width: 50%;
  margin-bottom: 2rem;
  margin-top: 1.5rem;
`
